module.exports = __webpack_public_path__ + "img/btn_google_bw.8e9e489f.svg";